import { useContext, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '@mui/material';
import { TenantConfigContext } from 'context/TenantConfigContext';
import { useActivateTenant } from 'services/onbarding.service';
import { PoweredByTbOneFooter } from 'components/PoweredByTbOneFooter';
import { tbPalette } from 'styles/colors';

export function ReactivationPage() {
  const activateTenant = useActivateTenant();
  const [activating, setActivating] = useState(false);
  const { updateActivationStatus } = useContext(TenantConfigContext);

  const reactivate = () => {
    if (activating) return;

    setActivating(true);

    activateTenant()
      .then(response => {
        if (response.error) {
          console.error(response.error);
          updateActivationStatus('INACTIVE');
        } else {
          updateActivationStatus(response.data ?? 'ACTIVATING');
        }
      })
      .catch(error => {
        console.error(error);
        updateActivationStatus('INACTIVE');
      })
      .finally(() => {
        setActivating(false);
      });
  };

  return (
    <div className="flex flex-col h-screen">
      <div className="flex flex-grow items-center mx-auto max-w-7xl gap-10">
        <img
          src="/illustrations/ModulesUsers.svg"
          alt="Reactivation Illustration"
          className="block max-w-fit w-[32rem]"
        />

        <div className="py-5 max-w-4xl">
          <div className="flex flex-col gap-4 text-left">
            <div className="max-w-2xl">
              <h2 className="text-[26px] font-bold text-gray-900">
                <FormattedMessage id="activation.reactivation.headline" />
              </h2>
            </div>

            <p className="text-base text-gray-700">
              <FormattedMessage id="activation.reactivation.description" />
            </p>

            <p className="text-base text-gray-700">
              <FormattedMessage id="activation.reactivation.notification" />
            </p>

            <h4 className="text-lg font-semibold text-gray-900">
              <FormattedMessage id="activation.reactivation.footer" />
            </h4>

            <div className="flex mt-2">
              <Button disabled={activating} sx={{ backgroundColor: tbPalette.background.dark }} onClick={reactivate}>
                <FormattedMessage id="activation.reactivation.button" />
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-auto">
        <PoweredByTbOneFooter />
      </div>
    </div>
  );
}
